export const KitContract  = {
    async index(page, per_page, search) {
        page;
        per_page;
        search;

        throw new Error("index_kit not implemented");
    },
}